import { Shape }      from '@tokamap/core';
import { ShapeImage } from '@tokamap/core';
import { ShapeText }  from '@tokamap/core';

const MIN_HEIGHT_RATIO = 0.45;

export const STACKED_IMAGE: Partial<ShapeImage> = { scale: 0.45, verticalAlign: 0.25 };
export const STACKED_TEXT: Partial<ShapeText> = { size: 0.5, verticalAlign: 0.75 };

function heightRatio(shape: Shape): number {
	if (shape.coordinates.length < 2) return 0;

	const lngs = shape.coordinates.map(([lng]) => lng);
	const lats = shape.coordinates.map(([, lat]) => lat);
	const midLat = (Math.min(...lats) + Math.max(...lats)) / 2;
	const width = (Math.max(...lngs) - Math.min(...lngs)) * Math.cos(midLat * Math.PI / 180);
	const height = Math.max(...lats) - Math.min(...lats);

	return width > 0 ? height / width : 0;
}

export default function canStackPlaceContent(shape: Shape): boolean {
	if (shape.shapeKind === 'line' || shape.shapeKind === 'image') return false;

	const image = shape.image;
	const text = shape.text;

	const imageCustomized = image?.scale !== undefined || image?.verticalAlign !== undefined || image?.horizontalAlign !== undefined;
	const textCustomized = text?.size !== undefined || text?.fixedSizePx !== undefined || text?.verticalAlign !== undefined;

	if (imageCustomized || textCustomized) return false;

	return heightRatio(shape) >= MIN_HEIGHT_RATIO;
}
